import  { useEffect, useState, useMemo } from 'react';

export const useCacheContext = () => {
    // SIGN IN
    const [cacheState, setCacheState] = useState<string>('events');
    

    const contextValue = useMemo(() => ({
        cacheState, 
        setCacheState,
    }), [
        cacheState, 
        setCacheState,
    ]);

    return contextValue;

}

export type CacheContextValue = ReturnType<typeof useCacheContext>;